import { Box, ButtonV2, DialogV2, Flex, styled } from '@withjoy/joykit';
import type { ButtonOverrides } from '@withjoy/joykit/components/ButtonV2/Button.types';

export const StyledDialog = styled(DialogV2)`
  > div > div {
    max-height: 520px;

    ${props => props.theme.mediaQueries.sm} {
      max-width: 640px;
      min-width: 640px;
    }
  }

  > div > div > div:nth-of-type(2) {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .joykit-dialog-header {
    background-color: #fff;
    min-height: unset;

    > span > h1 {
      margin-bottom: 16px;
    }
  }
`;

export const StyledFlex = styled(Flex)`
  flex-direction: column;

  ${props => props.theme.mediaQueries.sm} {
    flex-direction: row;
  }
`;

export const StyledMobileDialogContent = styled(Box)`
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  margin: 0;
  border-radius: 10px;
  background-color: white;
`;

export const StyledMobileDialog = styled(DialogV2)`
  > div > div {
    max-height: 325px;
    min-height: 325px;
  }
`;

export const StyledAppButton = styled(ButtonV2)`
  width: 100%;
`;

export const registryPrimaryButtonStyles: ButtonOverrides = {
  Root: {
    props: {
      color: 'white',
      backgroundColor: 'mono14',
      _hover: {
        color: 'white',
        backgroundColor: 'mono11',
      },
      _active: {
        color: 'white',
        backgroundColor: 'black',
      },
      _disabled: {
        color: 'mono8',
        backgroundColor: 'mono3',
      },
    },
  },
};

export const registryOutlineButtonStyles: ButtonOverrides = {
  Root: {
    props: {
      color: 'mono14',
      borderColor: 'mono14',
      _hover: {
        color: 'mono14',
        borderColor: 'mono14',
        backgroundColor: 'mono5',
      },
    },
  },
};

export const registryLinkButtonStyles: ButtonOverrides = {
  Root: {
    props: {
      color: 'mono14',
      _hover: { color: 'mono11' },
    },
  },
};

export const styles = {
  registryPrimaryButton: registryPrimaryButtonStyles,
  registryOutlineButton: registryOutlineButtonStyles,
  registryLinkButton: registryLinkButtonStyles,
};
